import { List } from "../../../@types/list";
import {
  AnsweringClient,
  IUserResponse,
  SearchAllUsersParams,
} from "../../../clients/answeringClient";

export interface AllUsersControllerDelegate {
  didGetAllUsers(response: List<IUserResponse>): void;
  genericError(message: string): void;
}

export class AllUsersController {
  constructor(
    private delegate: AllUsersControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  public async searchUsers(accessToken: string, params: SearchAllUsersParams) {
    try {
      const response = await this.answeringClient.searchAllUsers(
        accessToken,
        params
      );
      this.delegate.didGetAllUsers(response.data);
    } catch (error: any) {
      console.error("Failed to search all users:", error);
      const errorMessage =
        error?.response?.data?.message ||
        "Ocorreu um erro ao buscar os usuários. Tente novamente.";
      this.delegate.genericError(errorMessage);
    }
  }
}
